import { render, staticRenderFns } from "./OliSync.vue?vue&type=template&id=f1a89cce&scoped=true"
import script from "./OliSync.vue?vue&type=script&lang=js"
export * from "./OliSync.vue?vue&type=script&lang=js"
import style0 from "./OliSync.vue?vue&type=style&index=0&id=f1a89cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a89cce",
  null
  
)

export default component.exports